import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callRequestStatusApi } from "api/callRequestStatusApi";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useCallRequestStatus = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: callRequestStatusApi,

    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["user-request-list"],
        exact: false,
      });

      AlertNotification("success", "Call request updated");

      if (options?.onSuccess) options.onSuccess(data, variables);
    },

    onError: (error, variables) => {
      AlertNotification("error", error.message || "Update failed");

      if (options?.onError) options.onError(error, variables);
    },
  });
};
